<!-- 由 woniu6162 创建于 2021-10-20 星期三 -->
<template>
  <div class="p-card">
    <div class="pc_info">
      <div class="pc_i_rank">{{ datum.rank }}</div>
      <img :src="datum.avatar" class="pc_i_pic" />
      <div class="pc_i_info">
        <div class="pc_ii_up">
          <div class="pc_iiu_name">{{ datum.nickname }}</div>
          <div
            class="pc_iiu_copy"
            :data-clipboard-text="datum.nickname"
            @click="tapCopy('.pc_iiu_copy')"
          >
            复制昵称
          </div>
        </div>
        <div class="pc_ii_down">
          <div class="pc_iid_left">
            <div class="pc_iid_fans">
              {{ `粉丝 ${datum.follower_count2}` }}
            </div>
            <div class="pc_iid_effect">影响力</div>
            <div class="pc_iid_hot">
              <img :src="hotPic" class="pc_iidh_pic" />
              <div class="pc_iidh_val">{{ datum.effect_value2 }}</div>
            </div>
          </div>
          <div class="pc_iid_recent" @click="tapVideo">
            <div>最近视频</div>
            <i
              :class="['iconfont', 'iconxiala', showVideo ? 'rotate_icon' : '']"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="pc_video" v-show="showVideo">
      <div class="pc_v_out">
        <template v-for="(si, ii) in datum.video_list">
          <div :key="ii" class="pc_vo_wrap">
            <div class="pc_vow_out">
              <img :src="si.item_cover" class="pc_vow_video" />
              <!-- <img
                :src="playPic"
                class="pc_vow_play"
                @click="viewVideo(si.share_url)"
              /> -->
              <div
                class="pc_vow_copy"
                :data-clipboard-text="si.share_url"
                @click="tapCopy('.pc_vow_copy')"
              >
                <i class="iconfont iconlianjie" />
                <div>复制播放链接</div>
              </div>
            </div>
            <div class="pc_vow_name">{{ si.title }}</div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Clipboard from 'clipboard'
export default {
  name: 'p-card',

  mixins: [],

  components: {},

  props: {
    datum: {}
  },

  data() {
    return {
      showVideo: false,
      hotPic: 'https://cdnvue.gymcity.com.cn/uploads/trackhot_hot',
      playPic: 'https://cdnvue.gymcity.com.cn/uploads/trackhot_play'
    }
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {
    // 展示最近视频
    tapVideo() {
      this.showVideo = !this.showVideo
    },
    // 复制名称
    tapCopy(val) {
      let clipboard = new Clipboard(val)
      clipboard.on('success', () => {
        this.$toast.success('复制成功')
        clipboard.destroy()
      })
      clipboard.on('error', () => {
        this.$toast.fail('复制失败，请手动复制')
      })
    },
    viewVideo(url) {
      this.$emit('viewVideo', url)
    }
  }
}
</script>

<style lang="scss" scoped>
.p-card {
  margin-top: 2.7vw;
  width: 91.5vw;
  background-color: #ffffff;
  border-radius: 1.1vw;
  padding: 3.2vw;
  box-sizing: border-box;
  .pc_info {
    display: flex;
    align-items: center;
    color: rgba(0, 0, 0, 0.5);
    .pc_i_rank {
      width: 6.5vw;
      text-align: left;
      font-size: 4vw;
    }
    .pc_i_pic {
      margin-left: 2.3vw;
      width: 10.7vw;
      height: 10.7vw;
      background-color: #d8d8d8;
      border-radius: 50%;
    }
    .pc_i_info {
      margin-left: 2.7vw;
      text-align: left;
      font-size: 3.2vw;
      width: 100%;
      .pc_ii_up {
        display: flex;
        align-items: center;
        .pc_iiu_name {
          max-width: 47.3vw;
          font-size: 4.3vw;
          color: #000;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;
        }
        .pc_iiu_copy {
          margin-left: 2.7vw;
          color: rgba(0, 0, 0, 0.5);
        }
      }
      .pc_ii_down {
        margin-top: 0.8vw;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .pc_iid_left {
          display: flex;
          align-items: center;
          .pc_iid_effect {
            margin-left: 2.7vw;
          }
          .pc_iid_hot {
            // margin-left: 1.1vw;
            display: flex;
            align-items: center;
            .pc_iidh_pic {
              margin-left: 1.1vw;
              width: 2.1vw;
              object-fit: cover;
            }
            .pc_iidh_val {
              margin-left: 0.5vw;
              font-size: 3.5vw;
              font-weight: 600;
              color: #ff5c5c;
            }
          }
        }
        .pc_iid_recent {
          display: flex;
          align-items: center;
          font-size: 3.5vw;
          color: rgba(0, 0, 0, 0.5);
          & > i {
            margin-left: 1.3vw;
            font-size: 2.4vw;
            color: #ccc;
          }
          .rotate_icon {
            transform: rotate(180deg);
          }
        }
      }
    }
  }
  .pc_video {
    margin-top: 6.1vw;
    margin-bottom: 2vw;
    width: 100%;
    box-sizing: border-box;
    overflow: auto;
    &::-webkit-scrollbar {
      width: 0;
      height: 0;
    }
    .pc_v_out {
      margin-left: -2.7vw;
      width: fit-content;
      padding: 0 3.4vw;
      display: flex;
      .pc_vo_wrap {
        margin-left: 2.7vw;
        width: 24.5vw;
        box-sizing: border-box;
        .pc_vow_out {
          width: 24.5vw;
          height: 32.8vw;
          border-radius: 0.5vw;
          background-color: rgba(0, 0, 0, 0.5);
          overflow: hidden;
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          .pc_vow_video {
            position: absolute;
            top: 0;
            left: 0;
            width: 24.5vw;
            height: 32.8vw;
            box-sizing: border-box;
            border-radius: 0.5vw;
          }
          .pc_vow_play {
            width: 10.7vw;
            height: 10.7vw;
            position: relative;
            z-index: 1;
          }
          .pc_vow_copy {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 2.7vw;
            line-height: 5vw;
            font-weight: 600;
            color: #ffffff;
            position: absolute;
            z-index: 1;
            bottom: 1.9vw;
            background: linear-gradient(
              180deg,
              rgba(0, 0, 0, 0.3),
              rgba(0, 0, 0, 0.02)
            );
            & > i {
              margin-right: 0.8vw;
              font-size: 3.2vw;
              font-weight: normal;
            }
          }
        }
        .pc_vow_name {
          margin-top: 2.1vw;
          text-align: left;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
    }
  }
}
</style>
